import React from 'react';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import EventClientSubTabs from './SubTabs.js';


const AntTabs = withStyles({
  root: {
    borderRadius: '8px 8px 0px 0px',
    borderBottom: '1px solid #e8e8e8',
  },
  indicator: {
    backgroundColor: 'white',
  },
})(Tabs);

const AntTab = withStyles((theme) => ({
  root: {
    'textTransform': 'none',
    'minWidth': 72,
    'fontWeight': theme.typography.fontWeightRegular,
    'marginRight': theme.spacing(4),
    'color': 'white',
    'fontSize': '16px',
    'marginLeft': '32px',
    [theme.breakpoints.down(769)]:
    {
      fontSize: '14px !important',
    },

    '&.MuiTab-textColorInherit': {
      opacity: '0.9 !important',
    },
    '&:hover': {
      color: 'white',
      opacity: 1,
    },
    '&$selected': {
      color: '#296bff',
      minHeight: '36px',
      backgroundColor: 'white',
      marginTop: '8px',
      marginBottom: '8px',
      padding: '8px',
      borderBottom: '0px',
      borderRadius: '4px',
      fontWeight: '600',
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  padding: {
    padding: theme.spacing(3),
  },
  demo1: {
    backgroundColor: '#296bff',
    color: 'white',
    borderRadius: '6px',
  },
}));

export default function EventClientTabs() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div className={classes.root}>
      <div>
        <AntTabs
          className="tab-active"
          value={value}
          onChange={handleChange}
          aria-label="ant example"
          variant="scrollable"
          scrollButtons="auto"
        >
          <AntTab label="Client Event Tactics" />
        </AntTabs>
        <Typography />
      </div>
      <div className={classes.subContent}>
        {value === 0 && (
          <EventClientSubTabs />
        )}
      </div>
    </div>
  );
}
